import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DragHandleIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "DragHandle",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M12 2h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H12c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1m0 6h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H12c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1m0 6h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H12c-.55 0-1-.45-1-1V15c0-.55.45-1 1-1m0 6h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H12c-.55 0-1-.45-1-1V21c0-.55.45-1 1-1m6-18h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H18c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1m0 6h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H18c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1m0 6h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H18c-.55 0-1-.45-1-1V15c0-.55.45-1 1-1m0 6h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H18c-.55 0-1-.45-1-1V21c0-.55.45-1 1-1m-6 5.99h2.01c.55 0 1 .45 1 1V29c0 .55-.45 1-1 1H12c-.55 0-1-.45-1-1v-2.01c0-.55.45-1 1-1m6 0h2.01c.55 0 1 .45 1 1V29c0 .55-.45 1-1 1H18c-.55 0-1-.45-1-1v-2.01c0-.55.45-1 1-1"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("circle", {
        cx: "10.14",
        cy: "4.14",
        r: "1.14"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "10.14",
        cy: "4.14",
        r: "2.29"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "10.14",
        cy: "15.57",
        r: "1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.14 17.86c-1.26 0-2.29-1.03-2.29-2.29s1.03-2.29 2.29-2.29 2.29 1.03 2.29 2.29-1.03 2.29-2.29 2.29"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "10.14",
        cy: "27",
        r: "1.14"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "10.14",
        cy: "27",
        r: "2.29"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "21.57",
        cy: "4.14",
        r: "1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.57 6.43c-1.26 0-2.29-1.03-2.29-2.29s1.03-2.29 2.29-2.29 2.29 1.03 2.29 2.29-1.03 2.29-2.29 2.29m0-2.29"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "21.57",
        cy: "15.57",
        r: "1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.57 17.86c-1.26 0-2.29-1.03-2.29-2.29s1.03-2.29 2.29-2.29 2.29 1.03 2.29 2.29-1.03 2.29-2.29 2.29"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "21.57",
        cy: "27",
        r: "1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.57 29.29c-1.26 0-2.29-1.03-2.29-2.29s1.03-2.29 2.29-2.29 2.29 1.03 2.29 2.29-1.03 2.29-2.29 2.29m0-2.29"
      })]
    })
  }));
};